import { Controller } from 'stimulus';

import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['children', 'name'];

  initialize() {
    this.childrenCount = parseInt(this.data.get('childrenCount'));
    this.childrenVisible = false;
    this.id = this.data.get('id');
  }

  connect() {
    this.checkChildrenCountAndVisibility();
  }

  checkChildrenCountAndVisibility() {
    if (this.childrenCount > 0 && !this.childrenVisible) {
      this.nameTarget.classList.add('has-text-weight-bold');
    } else {
      this.nameTarget.classList.remove('has-text-weight-bold');
    }
  }

  hideChildren() {
    this.childrenTarget.innerHTML = '';
    this.childrenVisible = false;
  }

  moveTo(parent_id, new_position) {
    let data = new FormData();
    data.append('category[id]', this.id);
    data.append('category[new_position]', new_position);
    if (parent_id) {
      data.append('category[parent_id]', parent_id);
    }

    Rails.ajax({
      dataType: 'script',
      type: 'PATCH',
      url: `/office/catalog/categories/${this.id}`,
      data: data,
      error: () => {
        alert('Произошла ошибка при обновлении данных!');
      }
    });
  }

  showChildren() {
    if (this.childrenCount <= 0) {
      return;
    }

    const controller = this;
    Rails.ajax({
      type: 'GET',
      url: this.data.get('childrenUrl'),
      error: () => {
        alert('Произошла ошибка при загрузке данных!');
      },
      success: (response) => {
        controller.childrenTarget.innerHTML = response.body.innerHTML;
        controller.childrenVisible = true;

        controller.checkChildrenCountAndVisibility();
        controller.application.getControllerForElementAndIdentifier(controller.childrenTarget, 'office--catalog--categories')
          .initSortable();
      }
    });
  }

  toggleChildren() {
    if (this.childrenVisible) {
      this.hideChildren();
    } else {
      this.showChildren();
    }

    this.checkChildrenCountAndVisibility();
  }
}
